import { Box, Typography } from '@mui/material';
import React from 'react';

interface FormFieldSectionProps {
    title: string;
    children: React.ReactNode;
}

/** Plain, permanently visible grouping for optional form fields. */
export function FormFieldSection({
    title,
    children,
}: FormFieldSectionProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                '& + &': { mt: 3 },
            }}
        >
            <Typography
                variant={'subtitle2'}
                color={'text.secondary'}
                sx={{
                    fontWeight: 700,
                    borderBottom: 1,
                    borderColor: 'divider',
                    pb: 0.5,
                }}
            >
                {title}
            </Typography>
            {children}
        </Box>
    );
}
